import { z } from 'zod'

import { AvailabilityTypes } from './AvailabilityTypes'

export const CAACountByAvailability = z.object({
  availability: AvailabilityTypes,
  amount: z.number()
})
export type CAACountByAvailability = z.infer<typeof CAACountByAvailability>
